// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1844":"9120d54a","2565":"a772ed98","4272":"b8f89663"}[chunkId] + ".chunk.css";
};